import { render } from "./JsonLinter.vue?vue&type=template&id=b922bdb2&scoped=true&lang=pug"
import script from "./JsonLinter.vue?vue&type=script&lang=js"
export * from "./JsonLinter.vue?vue&type=script&lang=js"

import "./JsonLinter.vue?vue&type=style&index=0&id=b922bdb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b922bdb2"]])

export default __exports__